<template>
  <div class="has_market_price">
    <!-- Header Included here -->
    <Header />
    <nav class="navbar navbar-light navbar-expand-md">
      <div class="container-fluid">
        <div class="container justify-content-center">
          <ul class="nav navbar-nav navcol-1">
            <li class="nav-item" role="presentation">
              <router-link class="nav-link" to="#">Partnership</router-link>
            </li>
            <li class="nav-item" role="presentation">
              <router-link class="nav-link" to="terms-of-use"
                >Terms of use</router-link
              >
            </li>
            <li class="nav-item" role="presentation">
              <router-link class="nav-link" to="terms-of-sale"
                >Terms of Sale</router-link
              >
            </li>
            <li class="nav-item" role="presentation">
              <router-link class="nav-link active" to="/privacy-policy"
                >Privacy Policy</router-link
              >
            </li>
            <li class="nav-item" role="presentation">
              <router-link class="nav-link" to="/faqs">FAQs</router-link>
            </li>
          </ul>
        </div>
        <a class="navbar-brand" href="#"></a>
      </div>
    </nav>

    <div class="container no_scroll">
      <div class="row my-3 no_scroll">
        <div class="col-lg-9 mx-auto">
          <div class="pr-3 pt-2 no_scroll" style="height:80vh;">
            <h5 class="mb-4">Privacy Policy</h5>
            <p id="legal-text-content"></p>
            <h6>General overview:</h6>
            <p>
              We&rsquo;ve tried to cover the following areas in the privacy
              policy.
            </p>

            <ol>
              <li>How Personal Information about you is used?</li>
              <li>
                What Personal Information about you does Quick Leap Gather?
              </li>
              <li>What about Cookies?</li>
              <li>
                What is the accuracy of the Personal data provided to Quick
                Leap?
              </li>
              <li>How Secure is Information about Me?</li>
              <li>Examples of Information Collected</li>
              <li>What are your rights?</li>
            </ol>

            <p>
              <b>QUICKLEAP GLOBAL LIMITED</b>(&ldquo;QuickLeap&rdquo;,
              &ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;
              &ldquo;Company&rdquo;), recognizes your privacy rights as
              guaranteed under the 1999 Constitution of the Federal Republic of
              Nigeria; The Nigerian Data Protection Regulation, and other
              applicable privacy laws in Nigeria. Thus, it is important
              to&nbsp;us as a law-abiding organization that your Personal Data
              is managed, processed and protected in accordance with the
              provisions of the applicable laws. In the course of our business
              and/or your engagement with us and third parties through our
              Platforms (this includes but are not limited to our websites,
              digital platforms, mobile applications, physical
              operations/offices, amongst others), we may process your Personal
              Data, subject however to the terms of this Policy.
            </p>

            <p>
              This Privacy Policy (&ldquo;Policy&rdquo;) therefore explains our
              privacy practices with respect to how we collect and process your
              Personal Data and describes your rights as a user of any of our
              services and Platforms. This Policy applies to all our Platforms,
              and all related sites, applications, services and tools regardless
              of how they are accessed or used. In this Privacy Policy,
              &ldquo;we&rdquo;, &ldquo;us&rdquo; or &ldquo;our&rdquo; refers to
              QUICKLEAP GLOBAL Limited and its successors, agents and assigns,
              while &ldquo;you&rdquo;, &ldquo;your&rdquo; refers to you and/or
              any person who subscribes for, uses or authorizes the use of the
              Service. As a user of any of our Platforms, you accept this
              Privacy Policy when you sign up for, or use our products,
              services, content, technologies or functions offered on our
              Platforms and all related sites and services
              (&ldquo;Services&rdquo;). Our Privacy Policy explains our
              user&rsquo;s privacy rights regarding:
            </p>

            <p>
              a.What information we collect
              <br />b. Why we collect such information <br />c.&nbsp; The use of
              such information <br />d. The storage, sharing and protection of
              such information
            </p>

            <p>
              Definitions For the purpose of this Policy:
              <br />
              <br />
              <strong>Personal Data/Information</strong> means any information
              relating to you, including your name, identification number,
              location data, online identifier address, photo, email address,
              pins, passwords, bank details, posts on our Platforms, religion,
              date of birth, health, race/tribe, nationality, ethnicity,
              political views, trade union membership, criminal records, medical
              information, and other unique identifiers such as but not limited
              to MAC address, IP address, IMEI number, Bank Verification Number,
              IMSI number, SIM and others. It also includes factors specific to
              your physical, physiological, genetic, mental, economic, cultural
              or social identity.
            </p>

            <p>
              <strong>Process/Processing</strong> means any operation or set of
              operations which is performed on your Personal Data or sets of
              Personal Data, whether or not by automated means, such as
              collection, recording, organisation, structuring, storage,
              adaptation or alteration, retrieval, consultation, use, disclosure
              by transmission, dissemination or otherwise making available,
              alignment or combination, restriction, erasure or destruction.
            </p>

            <h5>Consent</h5>

            <p>
              We kindly request that you carefully read through this Policy and
              click on the &lsquo;Agree&rsquo; icon below, if you consent to the
              terms of this Policy, particularly with respect to the processing
              of your Personal Data. That notwithstanding, if you proceed to use
              any of our Platforms and services, it will deemed that you have
              provided your express consent to the terms of this Policy.
            </p>

            <h5>Age</h5>

            <p>
              You must be at least 18 years old to use our services or any of
              our Platforms. Individuals under the age of 18, or applicable age
              of maturity, may utilize our Platforms services only with
              involvement of a parent or legal guardian, under such
              person&rsquo;s account. Regardless, all Personal Data which we may
              process shall be in accordance with this Policy and other
              applicable laws.
            </p>

            <h5>Collection of Personal Data</h5>

            <p>
              In the course of your engagement with us or with third parties
              through our Platforms, we may collect your Personal Data in the
              following ways:
            </p>

            <p>
              &bull; Automatic Information collection: We may automatically
              collect Information upon your engagement with us or our Platforms
              through your computer, mobile phones, forms, documents made
              available to us and other access devices. The information sent
              includes, but is not limited to, data about our pages you access,
              geo-location information; statistics on page views; traffic to and
              from our Platforms.
            </p>

            <p>
              &bull; Information from downloads: When you download or use our
              digital Platforms or access our site, we may receive non personal
              information from your mobile device about your location, number of
              downloads, geo location of downloads. You may disable your
              location in the settings menu of the device.
            </p>

            <p>
              &bull; Physically or Digitally Provided Information: We may
              collect and process your information when you create and/or update
              your account on our Platform; complete forms, questionnaires,
              surveys etc. We may also collect Information from data you provide
              to us through documents, letters, e-mail, agreements,
              correspondence, ID cards, passports, or through any other means by
              which you willfully provide information to us.
              <br />
              <br />When you use Quick Leap Services, we may also collect
              information about your transactions and your activities. In
              addition, when you open an account on our Platform, we may collect
              information such as your contact information, which includes your
              name, address, phone number, email or other similar information;
              financial information such as your full bank account numbers
              and/or credit card or debit card numbers.
            </p>

            <p>
              &bull;
              <b>Third Parties:</b> We may also receive your information from
              third parties such as, guardians, financial institutions, identity
              verification services, vendors, and service providers etc.
            </p>

            <p>
              &bull;
              <b>Social Media:</b> We also receive Information through your
              engagements with us on social media sites (e.g., Facebook,
              Instagram, LinkedIn, Twitter, etc). This includes but is not
              limited to your replies to our posts, your comments, enquiries,
              messages to us, etc. We may also collect information from your
              public profile and updates on social media. Accessing your
              Personal Information When accessing our Platforms, we may collect
              information about you and your interactions with the Services to
              which we undertake to keep secure and confidential.
            </p>

            <p>
              We may offer you the ability to connect with our Platforms using a
              mobile device, either through a mobile application (App),
              computer, mobile optimized website, or by any other means. The
              provisions of this Privacy Policy apply to all such mobile access
              and use of mobile devices.
              <br />When you download or use our mobile applications, or access
              one of our mobile optimized sites, we may receive information
              about your location and your mobile device, including a unique
              identifier for your device. We may use this information to provide
              you with location-based services, such as advertising, search
              results, and other personalized content. <br />Most mobile devices
              allow you to control or disable location services in the
              device&#39;s setting&#39;s menu. If you have questions about how
              to disable your device&rsquo;s location services, we recommend you
              contact your mobile service carrier or the manufacture of your
              particular device.
            </p>

            <p>
              Using Your Personal Information In the course of your engagements
              with us or through our Platforms, we collect personal information
              for various legal reasons, largely to enable us to personalize
              your experience and to provide a more efficient service to you.
              <br />&nbsp;
            </p>

            <p>Some of the reasons we collect Information are to:</p>

            <p>&bull; provide services and customer support;</p>

            <p>
              &bull; process transactions, payment requests, and send notices
              about transactions;
            </p>

            <p>
              &bull; create an account with us for the provision or use of our
              services;
            </p>

            <p>
              &bull; communicate with you about your account or transactions
              with us and send you information or request feedback about
              features on our website and applications or changes to our
              policies;
            </p>

            <p>
              &bull; send you periodic emails and updates pertaining to our
              products and services;
            </p>

            <p>
              &bull; verify customers&rsquo; identity, including during account
              creation and password reset processes;
            </p>

            <p>
              &bull; manage your account and provide you with efficient customer
              service,
            </p>

            <p>
              &bull; send you offers and promotions for our services and
              investment opportunities
            </p>

            <p>
              &bull; resolve disputes, process payments and troubleshoot
              problems;
            </p>

            <p>
              &bull; detect, investigate and prevent activities that may violate
              our policies or be illegal;
            </p>

            <p>
              &bull; manage risks, or to detect, prevent, and/or remediate
              fraud, violation of policies and applicable user agreements or
              other potentially prohibited or illegal activities;
            </p>

            <p>&bull; execute our contractual obligations to you;</p>

            <p>
              &bull; improve our services and functionality by customizing user
              experience;
            </p>

            <p>
              &bull; measure the performance of our services and improve their
              content and layout;
            </p>

            <p>
              &bull; manage and protect our information technology
              infrastructure;
            </p>

            <p>
              &bull; provide targeted marketing and advertising, provide service
              or transaction update notices, and deliver promotional offers
              based on communication preferences;
            </p>

            <p>
              &bull; obtain a means by which we may contact you; either by
              telephone, text (SMS), email messaging, social media, etc;
            </p>

            <p>
              &bull; conduct background checks, compare information for accuracy
              and verify same with third parties;
            </p>

            <p>
              &bull; identify or address a violation and administer our policies
              and terms of use;
            </p>

            <p>
              &bull; comply with legal, contractual and regulatory obligations;
            </p>

            <p>
              &bull; execute your specific requests or use same for a specific
              purpose as you may instruct;
            </p>

            <p>
              &bull; investigate and respond to your complaints or enquiries;
            </p>

            <p>
              &bull; process your access to our services, Platforms, or
              functions from time to time; If we intend to use any Personal
              Information in any manner that is not consistent with this Privacy
              Policy, you will be informed of such anticipated use prior to or
              at the time at which the Personal information is required and
              obtain your consent. Storage and protection of your Data
            </p>

            <p>
              We protect your personal Information using physical, technical,
              and administrative security measures to reduce the risks of loss,
              misuse, unauthorized access, unauthorised disclosure and
              alteration. Some of our safeguards include firewall protection,
              Virtual Private Network (VPN) protection, encryption of data,
              authorization keys for authorised access and strong passwords.
              Access to our various platforms is restricted to authorized users
              only.
              <br />Your Information is also stored on our secure servers as
              well as secure physical locations and cloud infrastructure (where
              applicable). Please be aware that, despite our best efforts, no
              security measures are perfect or impenetrable.
            </p>

            <p>
              We will retain your personal information for the length of time
              needed to fulfill the purposes outlined in this privacy policy
              unless a longer retention period is required or permitted by law.
              To dispose of personal data, we may anonymize it, delete it or
              take other appropriate steps.
              <br />Data may persist in copies made for backup and business
              continuity purposes for additional time. We will take all
              necessary measures to ensure that your personal Data is safe,
              however, you are also required to ensure that access codes, PINs,
              passwords, usernames, and all other information or hints that may
              enable third party access to your accounts on our Platforms are
              secure.
            </p>

            <p>
              We therefore strongly advise you to keep such information secure
              and confidential. If you use a third party&rsquo;s device
              (laptops, phones, public internet, etc.) to access your account,
              kindly ensure that you always log out.
              <br />Kindly note however that certain devices are programmed to
              save passwords or usernames, as such, we advise that you use third
              party devices with extreme caution. If you believe that an
              unauthorized person has accessed your information, please contact
              us immediately.
            </p>

            <h5>Processing your Information</h5>

            <p>
              In order to execute our obligations to you or process your
              transactions, we may be required to process your Information, such
              as your name, account number, account ID, contact details,
              shipping and billing address, or other information needed to
              complete the transaction.
              <br />We also work with third parties, including financial
              institutions, vendors, service providers, who at one point or the
              other facilitate transactions executed on our Platforms. For
              completeness, in the course of your engagement with us or use of
              our services and Platforms, we may share your information with
              different stakeholders, including but not limited to Financial
              institutions; service providers; Credit bureaus and collection
              agencies to report account or credit information; Quick Leap
              subsidiaries and affiliates; Regulatory or judicial authorities;
              or other third parties pursuant to a subpoena, court order, or
              other legal process or requirement applicable to Quick Leap.
              <br />Please note that the aforementioned parties may be within or
              outside Nigeria. We may also process your Information when we
              believe, in our sole discretion, that the disclosure of your
              Information is necessary to comply with applicable laws and
              judicial/regulatory orders; conduct investigations; manage
              existing or imminent risks, prevent fraud, crime or financial
              loss, or for public safety or to report suspected illegal activity
              or to investigate violations of our Terms and Conditions.
            </p>

            <p>
              In all cases, we will ensure that your Information is safe, and
              notify the receiving party of the confidential nature of your
              Information, particularly the need to maintain the confidentiality
              of same and prevent unlawful or unauthorised usage.
            </p>

            <p>
              Your Rights You have the following rights regarding your personal
              information collected by us:
            </p>

            <p>
              &bull; Right to access your personal information being held by us.
              Request for such information may be sent to
              <a href="mailto:hello@quickleapglobal.com. "
                >hello@quickleapglobal.com.</a
              >
              <br />
              <br />&bull; Right to request that your personal data be made
              available to you in an electronic format or that it should be sent
              to a third party (Kindly note that we have the right to decline
              such request if it is too frequent, unreasonable, and likely to
              cause substantial cost to us. In any event, we will communicate
              the reason for our refusal);
            </p>

            <p>
              &bull; Right to rectify any inaccurate, incomplete information. As
              such, if you discover any inaccuracy in your personal information,
              kindly notify us promptly and provide us with documentary evidence
              to enable us to update the requisite changes.
            </p>

            <p>
              &bull; Right to withdraw consent for the processing of your
              information, provided that such withdrawal shall not invalidate
              any processing hitherto done based on the consent previously given
              by you;
            </p>

            <p>
              &bull; Restrict or object to the processing of your personal data
              provided that we may be compelled to process your data where
              required under law, regulatory authorities, or court of law.
            </p>

            <p>
              &bull; Right to request that your personal data be deleted. We may
              however continue to retain the information where required under
              law, contract, regulatory authorities, or court of law.
              Disclosures We may share your personal information with:
            </p>

            <p>
              a. Members of the Quick Leap to provide joint content, products
              and services (such as registration, transactions and customer
              support), to help detect and prevent potentially illegal acts and
              violations of our policies, and to guide decisions about their
              products, services, and communications.
              <br />Members of the group will use this information to send you
              marketing communications and opportunities only if you have
              requested their services.
            </p>

            <p>
              b. Credit bureaus and collection agencies to report account or
              credit information, as permitted by law.
            </p>

            <p>
              c. Companies that we plan to merge with or are acquired by.
              (Should such a combination occur, we will require that the new
              combined entity follow this Privacy Policy with respect to your
              personal Information. If your personal Information could be used
              contrary to this policy, you will receive prior notice).
            </p>

            <p>
              d. Law enforcement, government officials, or other third parties
              pursuant to a subpoena, court order, or other legal process or
              requirement applicable to Quick Leap or one of its agents; when we
              need to do so to comply with law; or when we believe, in our sole
              discretion, that the disclosure of personal information is
              necessary to prevent physical harm or financial loss, to report
              suspected illegal activity or to investigate violations of our
              User Agreement.
              <br />Other unaffiliated third parties, for the following purposes
            </p>

            <p>
              &nbsp; a.
              <strong>Fraud Prevention and Risk Management:</strong> to help
              prevent fraud or assess and manage risk. <br />&nbsp;&nbsp;b.
              <strong>Customer Service:</strong> for customer service purposes,
              including to help service your accounts or resolve disputes.
              <br />&nbsp;&nbsp;c. <strong>Legal Compliance:</strong> to help
              them comply with anti-money laundering and counter-terrorist
              financing verification requirements. <br />&nbsp;&nbsp;d.
              <strong>Service Providers:</strong> to enable service providers
              under contract with us to support our business operations, such as
              fraud prevention, marketing, customer service and technology
              services. Our contracts dictate that these service providers only
              use your information in connection with the services they perform
              for us and not for their own benefit. Software If you download or
              use our software, such as a stand-alone software product, an app,
              or a browser plugin, you agree that from time to time, the
              software may download and install upgrades, updates and additional
              features from us in order to improve, enhance, and further develop
              the software. We may utilize your personal information to
              internally evaluate our software.
            </p>

            <h5>Period of Storage</h5>

            <p>
              We retain your information for as long as necessary for the
              purpose(s) for which it was collected. The period of data storage
              is also subject to legal, regulatory, administrative and
              operational requirements.
            </p>

            <h5>Exceptions</h5>

            <p>
              Please note that this Policy does not apply to Information that is
              already in the public domain through no fault of ours.
            </p>

            <h5>Violation</h5>

            <p>
              If you violate the letter or spirit of this Policy, or otherwise
              create risk or possible legal exposure for us or attempt to
              violate the privacy rights of Quick Leap Global and/or its other
              users, we reserve the right to restrict your access to our
              Platforms. We will notify you in the event that we are constrained
              to take such decision.
            </p>

            <h5>Dispute resolution</h5>

            <p>
              We are dedicated to ensuring that you are satisfied with our
              management of your Information. However, in the unlikely event
              that you have a complaint, please contact us via the details
              below, stating your name and details of your complaint. Upon
              receipt of your complaint we will endeavor to contact you within 3
              (three) working days with a view to amicably resolving such
              dispute within the shortest possible time. The foregoing
              notwithstanding, all disputes arising from this policy shall first
              be resolved by negotiation.
              <br />However, if parties fail to resolve the disputes amicably by
              such mutual consultations, parties shall further attempt to
              resolve the dispute by mediation.
            </p>

            <h5>Contact Us</h5>

            <p>
              If you have questions regarding your data privacy rights or would
              like to submit a related data privacy right request, kindly
              contact us via the information below:
            </p>

            <p>
              Quick Leap Global Limited
              <br />No 3 B Ayinde, Sanni Close, <br />Oregun, Ikeja,
              <br />Lagos, Nigeria
            </p>

            <p>
              <a href="mailto:hello@quickleapglobal.com" class="text-success"
                >hello@quickleapglobal.com</a
              >
              <br />
              <a href="tel:08134860483">+234 (0) 813 486 0483</a>
            </p>
            <p>
              Please allow up to 3 (three) working days for requests to be
              processed. The Company reserves the right to charge a reasonable
              fee to process excessive or repeated requests.
            </p>

            <h5>Amendment</h5>
            <p>
              We may amend or revise this Policy at any time by posting a
              revised version on our website. Notice of the amendment shall be
              posted on our website and the revised version will be effective
              from the date of publication. Kindly, note that your continued use
              of our Platform after the publication of the revised version
              constitutes your acceptance of our amended terms of the Policy.
            </p>
          </div>
        </div>
      </div>
    </div>

    <market-price />
  </div>
</template>

<script>
// import Header from "@/components/Header.vue";
import MarketPrice from "@/components/MarketPrice.vue";
import Header from "@/components/Header.vue";

export default {
  metaInfo: {
    title: "Quickleap",
    titleTemplate: "%s | Privacy Policy",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: { Header, MarketPrice }
};
</script>

<style scoped>
ol,
ul {
  padding-inline-start: 20px;
}
ol li {
  margin: 10px 0;
}
ul li {
  margin: 5px 0;
}
.nav-item {
  width: 150px !important;
  height: 40px !important;
  background: #000;
  border-radius: 210px;
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 576px) {
  .nav-item {
    width: 80px !important;
    height: 30px !important;
    margin-bottom: 5px !important;
  }
  .no_scroll {
    overflow: hidden !important;
    padding: auto auto auto 10px !important;
  }
  .navcol-1 {
    width: 100% !important;
    display: flex !important;
    flex-direction: row !important;
    justify-content: center !important;
    flex-wrap: wrap !important;
    margin-bottom: 0px !important;
    position: relative !important;
  }
  .nav-link {
    font-weight: 300;
    font-size: 10px !important;
    line-height: 14px;
  }
}
.nav-link {
  color: #fff !important;
  text-align: center;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 28px;
}
</style>
